import React from 'react';
import BreadCrum from '../breadcrum/BreadCrum';
import BusinessCards from '../../components/BusinessCards';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchAllFav } from '../../redux/services/servicesActions';
import Loading from '../../components/Loading';
import { FaRegHeart } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const MyFavourites = () => {
    const dispatch = useDispatch();
    const { favourites, isFavLoading } = useSelector((state) => state.services);

    useEffect(() => {
        dispatch(fetchAllFav());
    }, []);

    const hasFavourites = favourites && favourites.length > 0;

    return (
        <div className="container">
            <BreadCrum
                items={[
                    { title: 'Home', path: '/home' },
                    { title: 'My Favourites', path: '/customer/my-favourites' },
                ]}
            />
            <p className="text-center poly f-36 fw-normal color-primary mb-4 ">
                My Favorites
            </p>

            {isFavLoading ? (
                <Loading />
            ) : hasFavourites ? (
                <div className={`row`}>
                    {favourites.map((item, index) => {
                        return (
                            <div key={index} className='col-12 col-md-4 '>
                                <BusinessCards item={item?.business} type="favourite" />
                            </div>
                        );
                    })}
                </div>
            ) : (
                <div className="text-center py-5 my-5">
                    <div className="d-inline-flex align-items-center justify-content-center bg-light rounded-circle mb-4" style={{ width: '100px', height: '100px', color: '#1B4D3E', border: '1px solid #eaeaea' }}>
                        <FaRegHeart size={44} />
                    </div>
                    <h3 className="poly fw-normal color-primary mb-3" style={{ fontSize: '24px' }}>No Favorites Yet</h3>
                    <p className="text-muted mx-auto mb-4 poppins" style={{ maxWidth: '400px', fontSize: '15px', lineHeight: '1.6' }}>
                        Tap the heart icon on any salon or service to save them here for quick and easy access.
                    </p>
                    <Link to="/home" className="btn text-white px-4 py-2 rounded-pill poppins" style={{ backgroundColor: '#1B4D3E', fontSize: '15px', fontWeight: '500', transition: 'all 0.2s' }}>
                        Explore Salons
                    </Link>
                </div>
            )}
        </div>
    );
};

export default MyFavourites;

